<div class="head-count">
  <div class="styled-container">
    <div class="row-container">
      <div class="col">
        <emerald-card >
          <div class="content-container">
            <div class="header-row">
              <div class="heading-title">{{ vendorProfile.interviewStatus }}</div>
              <div class="filter">
                <div class="fs-field">
                  <span class="fs-label">Month</span>
                  <select class="native-select has-icon icon-cal" aria-label="Month" (change)="onMonthChange($any($event.target).value)">
                    <option *ngFor="let o of monthOptions" [value]="o.label" [selected]="o.value === preSelectedValue">{{ o.label }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="metrics">
            <div class="metric" *ngFor="let metric of metrics">
              <span class="label">{{ interviewStatus[metric.key] }}</span>
              <span class="value">{{ data?.[metric.key] || '0' }}</span>
            </div>
          </div>
        </emerald-card>
      </div>
    </div>
  </div>
</div>
